export const getVotingState = state => state.voting;

const EMPTY_VOTING_FOR_STOCK = Object.freeze({
  loading: false,
  error: null,
  voted: null,
  weekStartDate: null
});

export const getVotingForStock = (state, stockId) => {
  if (!stockId && stockId !== 0) return null;

  const voting = getVotingState(state);
  const key = String(stockId);

  return voting?.byStockId?.[key] ?? EMPTY_VOTING_FOR_STOCK;
};

